import { render, staticRenderFns } from "./cs1Footer.vue?vue&type=template&id=22a9c269&scoped=true"
import script from "./cs1Footer.vue?vue&type=script&lang=js"
export * from "./cs1Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a9c269",
  null
  
)

export default component.exports